import React, { FC } from 'react';
import {
  BooleanInput,
  NullableBooleanInput,
  Filter,
  ReferenceInput,
  DateInput,
  SelectInput,
  TextInput,
  FilterProps,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { LazyReferenceInput } from 'components/LazyAutoCompleteInput';
import { SupervisorReferenceInput } from 'components/SupervisorReferenceInput';
import { PhaseSelectInput } from '../components/PhaseSelectInput';

const lotStyles = makeStyles({
  input: {
    width: '7em',
  },
});

const contractorStyles = makeStyles({
  input: {
    width: '9em',
  },
  filterDate: {
    width: '100%',
    minWidth: '200px',
  },
});

export const RmMasterSheetFilter: FC<FilterProps> = props => {
  const lotClasses = lotStyles();
  const contractorClasses = contractorStyles();

  return (
    <Filter {...props}>
      <SupervisorReferenceInput source="supervisorUserIds||$cont" alwaysOn />
      <TextInput
        className={lotClasses.input}
        label="Lot"
        source="jobLot||$eq"
        alwaysOn
        resettable
        data-cy="RmMasterSheetFilterLot"
      />
      <TextInput
        className={lotClasses.input}
        label="Block"
        source="jobBlock||$eq"
        alwaysOn
        resettable
        data-cy="RmMasterSheetFilterBlock"
      />
      <LazyReferenceInput
        label="Builder"
        source="builderId"
        reference="builder"
        data-cy="RmMasterSheetFilterBuilder"
        filterToQuery={value => (value ? { name: value } : {})}
        sort={{ field: 'name', order: 'ASC' }}
        allowEmpty={false}
        resettable
        optionText="name"
        optionValue="id"
      />
      <LazyReferenceInput
        label="Subdivision"
        source="subdivisionId"
        reference="subdivision"
        data-cy="RmMasterSheetFilterSubdivision"
        resettable
        alwaysOn
        allowEmpty={false}
        filterToQuery={name => (name ? { name } : {})}
        sort={{ field: 'name', order: 'ASC' }}
        optionText="name"
        optionValue="id"
      />
      <SelectInput
        label="Workflow"
        source="phaseStructureType||$eq"
        data-cy="RmMasterSheetFilterWorkflow"
        choices={[
          { id: 'Drywall', name: 'Drywall' },
          { id: 'DrywallAndPaint', name: 'Drywall and Paint' },
        ]}
        allowEmpty={true}
        resettable
        alwaysOn
        className={contractorClasses.input}
        emptyText="All"
        options={{
          SelectProps: { displayEmpty: true },
          InputLabelProps: { shrink: true },
        }}
      />
      <ReferenceInput
        label="Phase"
        source="phaseId"
        reference="phase"
        data-cy="RmMasterSheetFilterPhase"
        perPage={Number.MAX_SAFE_INTEGER}
        sort={{ field: 'priority', order: 'ASC' }}
        allowEmpty={false}
        resettable
        alwaysOn
      >
        <PhaseSelectInput source="phaseId" label="Phase" applyDrywallAndPaintFilter={true} />
      </ReferenceInput>
      <BooleanInput
        source="requestIsOnTime"
        label="Request Is On Time"
        data-cy="RmMasterSheetFilterRequestOnTime"
      />
      <NullableBooleanInput
        className={contractorClasses.input}
        source="contractorHasBeenAssigned||$eq"
        label="Contractor"
        data-cy="ProdPayMasterSheetFilterShowAssigned"
        nullLabel="All"
        options={{
          SelectProps: { displayEmpty: true },
          InputLabelProps: { shrink: true },
        }}
        trueLabel="Assigned"
        falseLabel="Unassigned"
        alwaysOn
      />
      <DateInput
        className={contractorClasses.filterDate}
        label="Date Requested"
        source="jobPhaseDateRequested||$eq"
        alwaysOn
      />
      <LazyReferenceInput
        label="Region"
        source="regionId"
        reference="region"
        data-cy="RmMasterSheetFilterRegion"
        allowEmpty={false}
        filterToQuery={value => (value ? { name: value } : {})}
        sort={{ field: 'name', order: 'ASC' }}
        optionText="name"
        optionValue="id"
      />
    </Filter>
  );
};
